import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadComponent } from '../lib/download/download.component';
import { JackpotAssetsComponent } from '../lib/jackpot-assets/jackpot-assets.component';

const routes: Routes = [
  { path: '', redirectTo: '/jackpot-assets', pathMatch: 'full' },
  {
    path: 'jackpot-assets',
    component: JackpotAssetsComponent,
  },
  {
    path: 'download',
    component: DownloadComponent,
  },
  {
    path: 'content/support',
    loadComponent: () => import('@thehubz/client/help-faq').then((m) => m.ClientHelpFaqComponent),
  },
  {
    path: 'content/:param',
    loadComponent: () => import('../lib/content/content.component').then((m) => m.ContentComponent),
  },
];

/**
 *  This class contain the main routing of application
 *
 * @export
 * @class AppRoutingModule
 */
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
